import React, { useState, useEffect, useRef } from "react";
import SwipeIndicatorStrip from "../questionContainer/subcomponents/swipeIndicatorStrip";
import PlayerLabel from '../shared/playerLabel';

function AvatarSection({ sectionIndex, sectionData, isDisabled, currentSelection, setCurrentSelection, isSubmitting, playerName, userColor, sectionClassName }) {

  const [dragging, setDragging] = useState(false);
  const [pos, setPos] = useState(0);
  const [itemWidth, setItemWidth] = useState(0);
  const dragRef = useRef();
  const itemRef = useRef();

  useEffect(() => {
    function handleResize() {
      updatePlacement();
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (sectionData) {
      if (itemRef.current) {
        updateItemWidth();
      }
    }
  }, [sectionData])

  useEffect(() => {
    if (itemWidth > 0) {
      moveStripToSelection(currentSelection);
    }
  }, [itemWidth]);

  useEffect(() => {
    console.log(currentSelection)
    if (!dragging) {
      moveStripToSelection(currentSelection);
    }
  }, [currentSelection, dragging]);

  // --> EVENTS
  // Down events
  const mouseDownEvent = (e) => {
    setDragging(true);
    dragRef.current = e.clientX - pos;
  }
  const touchDownEvent = (e) => {
    setDragging(true);
    dragRef.current = e.touches[0].clientX - pos;
  }
  // Move events
  const mouseMoveEvent = (e) => {
    if (dragging) {
      moveStrip(calculateMovement(e.clientX));
      updateStripPosition(pos);
    }
  }
  const touchMoveEvent = (e) => {
    if (dragging) {
      moveStrip(calculateMovement(e.touches[0].clientX));
      updateStripPosition(pos);
    }
  }
  // Up events 
  const mouseUpEvent = (e) => {
    setDragging(false);
  }
  const touchUpEvent = (e) => {
    setDragging(false);
  }

  // Click events

  const switchNextEvent = (e) => {
    switchStrip(1);
  }
  const switchPrevEvent = (e) => {
    switchStrip(-1);
  }

  //const switchSelection

  // --> STRIP PLACEMENT & UPDATES

  const moveStrip = (newPos) => {
    setPos(newPos);
  }
  const updateStripPosition = (newPos) => {
    let newSelection = calculateSelection(newPos);
    if (newSelection !== currentSelection) {
      setCurrentSelection(newSelection);
    }
  }
  const moveStripToSelection = (selection) => {
    if (selection > sectionData.length - 1) {
      selection = sectionData.length - 1;
    } else if (selection <= 0) {
      selection = 0;
    }
    setCurrentSelection(selection);
    let newPos = (selection * itemWidth) * -1;
    moveStrip(newPos);
  }
  const switchStrip = (factor) => {
    const newSelection = currentSelection + factor;
    if (newSelection >= 0 && newSelection < sectionData.length) {
      setCurrentSelection(newSelection);
    }
  }
  const calculateMovement = (pointerX) => {
    const sectionWidth = itemWidth * (sectionData.length - 1);
    let newPos = pointerX - dragRef.current;
    let overshoot;
    if (newPos > 0) {
      newPos = newPos / 3;
    } else if (newPos < sectionWidth * -1) {
      overshoot = newPos + sectionWidth;
      newPos = (newPos - overshoot) + (overshoot / 3);
    }
    return newPos
  }
  const calculateSelection = (refPos) => {
    let newSelection = (Math.floor((refPos - (itemWidth / 2)) / itemWidth) * -1) - 1;
    if (newSelection >= sectionData.length) {
      newSelection = sectionData.length - 1;
    } else if (newSelection < 0) {
      newSelection = 0;
    }
    return newSelection;
  }
  const updatePlacement = () => {
    updateItemWidth();
  }
  const updateItemWidth = () => {
    const calculatedWidth = itemRef.current.offsetWidth;
    setItemWidth(calculatedWidth);
  }

  return (
    <div className={`avatar-section ${sectionClassName} ${isDisabled ? '' : 'active'}`}>
      {isDisabled &&
        <PlayerLabel playerName={playerName} playerColor={userColor} />
      }
      <div
        className={`avatar-strip ${dragging ? 'dragging' : ''}`}
        style={{
          transform: `translateX(${pos}px)`
        }}>
        {sectionData.map((item, index) => (
          <div
            key={index}
            className={`avatar-item ${currentSelection === index ? 'current' : ''}`}
            ref={itemRef}>
            <img src={item.filename} alt={item.title} />
          </div>
        ))}
      </div>
      {!isDisabled &&
        <>
          <div
            className="section-interaction"
            style={{ top: sectionIndex * 33 + '%' }}
            onMouseDown={mouseDownEvent}
            onTouchStart={touchDownEvent}
            onMouseMove={mouseMoveEvent}
            onTouchMove={touchMoveEvent}
            onMouseUp={mouseUpEvent}
            onTouchEnd={touchUpEvent}
            onMouseLeave={mouseUpEvent}
          >
            <div
              className={`switch-button next`}
              onClick={switchNextEvent}
            ></div>
            <div
              className={`switch-button prev`}
              onClick={switchPrevEvent}
            ></div>
          </div>
        </>
      }
      <div 
        className={`section-background ${!isDisabled ? 'active' : ''} ${isSubmitting ? 'transitions' : ''}`}
        style={{ top: sectionIndex * 33 + '%' }}
      >
          <div className="interactive-border top">
            <SwipeIndicatorStrip />
          </div>
          <div className="interactive-border bottom">
            <SwipeIndicatorStrip />
          </div>
      </div>
    </div>
  )
  /*

<div className="swipe-indicator top"></div>
      <div className="swipe-indicator bottom"></div>


    const [length, setLength] = useState(0);
    const [transitionEnabled, setTransitionEnabled] = useState(true);
    const [touchPosition, setTouchPosition] = useState(null);

    useEffect(() => {
        if (props.items) {
            setLength(props.items.length);
        }
    }, [props.items]);

    const next = () => {
        props.setCurrentIndex((prevState) => prevState + 1);
    };

    const prev = () => {
        props.setCurrentIndex((prevState) => prevState - 1);

    };

    const handleTouchStart = (e) => {
        if(props.disabled) return;
        const touchDown = e.touches[0].clientX
        setTouchPosition(touchDown)
    }

    const handleTouchMove = (e) => {
        if(props.disabled) return;
        const touchDown = touchPosition

        if(touchDown === null) {
            return
        }

        const currentTouch = e.touches[0].clientX
        const diff = touchDown - currentTouch

        if (diff > 5) {
            next()
        }

        if (diff < -5) {
            prev()
        }

        setTouchPosition(null)
    }

    const handleTransitionEnd = () => {
        if (props.currentIndex <= -1) {
            setTransitionEnabled(false);
            props.setCurrentIndex(length-1);

        } else if (props.currentIndex >= length) {
            setTransitionEnabled(false);
            props.setCurrentIndex(0);
        }

        setTimeout(()=> {setTransitionEnabled(true);}, 50);
    }

    return (
        <div className="avatar-d-section-container">
            {props.currentPlayer && 
                <div className={`background-color ${props.position}`}>
                </div>
            }
            <div className="avatar-d-section-wrapper">
                {!props.disabled && 
                    <button onClick={prev} className={`avatar-d-left-arrow ${props.position}`}>
                    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 2L3 9L10 16" stroke="white" strokeWidth="4"/>
                    </svg>
                    </button>
                }
                <div
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    className="avatar-d-section-content-wrapper">
                    <div
                        className="avatar-d-section-content"
                        style={{
                            transform: `translateX(-${(props.currentIndex+1) * 100}%)`,
                            transition: !transitionEnabled ? 'none' : undefined,
                        }}
                        onTransitionEnd={() => handleTransitionEnd()}
                    >
                        {props.items && props.items.length > 1 && <img key={props.items[props.items.length - 1].id} src={props.items[props.items.length -1].filename} />}
                        {props.items &&
                            props.items.map((item) => {
                                return (
                                    <img key={item.id} src={item.filename} />
                                );
                            })}
                        {props.items && props.items.length > 1 && <img key={props.items[0].id} src={props.items[0].filename} />}
                    </div>
                </div>
                {!props.disabled &&
                    <button onClick={next} className={`avatar-d-right-arrow ${props.position}`}>
                        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 2L9 9L2 16" stroke="white" strokeWidth="4"/>
                        </svg>
                    </button>
                }
            </div>
            {props.disabled &&
                <div className={`avatar-player-name-wrapper  ${props.position}`}>
                    <div className={`avatar-player-name`} style={{  backgroundColor: props.userColor }}>
                        {props.confirmed && 
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 6.5L6.5 11L16 1.5" stroke="black" strokeWidth="3"/>
                            </svg>
                        }
                        <span>{props.playerName}</span>
                        
                    </div>
                    <div className={`player-name-right-arrow ${props.position}`} style={{ borderLeftColor: props.userColor }}></div>
                </div>
                }
        </div>
    );*/
}

export default AvatarSection;
